import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactDOM from 'react-dom';
import { useSnackbar } from 'notistack';
import Wrapper from '../../components/Wrapper';
import { getApplicationForm } from '../../services/procedures';
import ApplicationForm from './ApplicationForm';
import { Card, Grid, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    '& > *': {
      margin: '0.5rem 0',
    },
  },
  card: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4),
    marginLeft: -16,
  },
  mb: {
    marginBottom: theme.spacing(3),
  },
  root: {
    position: 'relative',
    width: '100%',

    '&>div': {
      width: '100%',
    },
  },
}));

const ProcedurePreview = () => {
  const [data, setData] = useState(null);
  const [step, setStep] = useState('menu');
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: procedureData } = await getApplicationForm();
        setData(procedureData);
      } catch (err) {
        enqueueSnackbar('Nie udało się pobrać danych', {
          variant: 'error',
        });
        console.error(err);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (step === 'menu') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [step]);

  return (
    <div className={classes.root}>
      {data && step === 'menu' && (
        <>
          <Grid container>
            <Grid item xs={12}>
              <Card className={classes.card}>
                <Typography variant='h4' className={classes.mb}>
                  Składanie wniosku
                </Typography>

                <Typography variant='h6' className={classes.mb}>
                  Wypełnij wniosek, aby podzielić się z nami opinią:
                </Typography>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => setStep('request')}
                >
                  <Typography variant='button'>Wypełnij wniosek</Typography>
                </Button>
              </Card>
            </Grid>
          </Grid>
        </>
      )}
      {step === 'request' && (
        <ApplicationForm
          setStep={setStep}
          content={data?.application_form_preview?.content}
        />
      )}
    </div>
  );
};

export default ProcedurePreview;

ReactDOM.render(
  <Wrapper overrideService='pp' productionPrefix='apv' seed='application-view'>
    <ProcedurePreview />
  </Wrapper>,
  document.getElementById('application-view'),
);
